export default {
  pickup: 'Afhalen',
  delivery: 'Bezorging',
  ongoing_order: 'Lopende bestelling',
  view_more: 'Tik voor details',
  status: {
    rejected: {
      title: 'Bestelling geweigerd',
      description: 'Tik voor details',
    },
    created: {
      description: 'Bestelling ontvangen',
    },
    reviewed: {
      description: 'Je bestelling is bekeken',
    },
  },
  order_type: {
    pickup: 'afhalen',
    delivery: 'bezorging',
  },
  order_status_toast: {
    order_reviewed: '#{{number}} Je bestelling is bekeken',
    order_confirmed: '#{{number}} Bevestigde tijd {{time}}',
    order_preparation_up_time_changed: '#{{number}} {{type}} tijd gewijzigd naar {{time}}',
    order_preparing: 'Je bestelling #{{number}} wordt bereid',
    order_rejected: '#{{number}} bestelling geweigerd',
  },
  error_messages: {
    failed_to_load: 'Er is iets misgegaan, probeer het opnieuw.',
  },
};
